@if (sponsoredAds && sponsoredAds.length) {
  @if (!isMobileView) {
    @if (sponsoredAds.length > 1) {
      <div [ngClass]="cssClass" class="sponsored-banner">
        <label>sponsored</label>
        <!-- Add conditional class and loading state -->
        <div #imageSliderRef class="keen-slider banner-image-slider" [class.slider-loading]="!isSliderReady">
          @for (ad of sponsoredAds; track ad.id) {
            <div class="keen-slider__slide">
              <ng-container *ngTemplateOutlet="webCard; context: { data: ad }"></ng-container>
            </div>
          }
          <!-- Optional loading indicator -->
          @if (!isSliderReady) {
            <div class="slider-loader">
              <div class="loading-spinner"></div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div [ngClass]="cssClass" class="sponsored-banner">
        <label>sponsored</label>
        <ng-container *ngTemplateOutlet="webCard; context: { data: sponsoredAds[0] }"></ng-container>
      </div>
    }
  }
  @if (isMobileView) {
    @if (sponsoredAds.length > 1) {
      <div [ngClass]="cssClass" class="sponsored-banner--mobile">
        <label>sponsored</label>
        <!-- Add conditional class for mobile slider too -->
        <div #imageSliderRef class="keen-slider banner-image-slider" [class.slider-loading]="!isSliderReady">
          @for (ad of sponsoredAds; track ad.id) {
            <div class="keen-slider__slide">
              <ng-container *ngTemplateOutlet="mobileCard; context: { data: ad }"></ng-container>
            </div>
          }
          <!-- Optional loading indicator for mobile -->
          @if (!isSliderReady) {
            <div class="slider-loader">
              <div class="loading-spinner"></div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div [ngClass]="cssClass" class="sponsored-banner--mobile">
        <label>sponsored</label>
        <ng-container *ngTemplateOutlet="mobileCard; context: { data: sponsoredAds[0] }"></ng-container>
      </div>
    }
  }
}

<ng-template #mobileCard let-data="data">
  <div class="flex-row-start-center gap-10">
    <div (click)="onBannerClick(data)" class="sponsored-banner--mobile__image-wrapper background-loading-small">
      <img [src]="data.imageUrl" alt="" appDefaultImage lazy="true" />
    </div>

    <div class="sponsored-banner--mobile__content">
      <p class="title">{{ data?.title || '' | humanize | truncateText: 40 }}</p>
      <p [innerHTML]="data?.subTitle | truncateText: 80" [tippy]="data?.subTitle" class="description"></p>
    </div>
  </div>
</ng-template>

<ng-template #webCard let-data="data">
  <div (click)="onBannerClick(data)" class="sponsored-banner__image-wrapper background-loading">
    <img [src]="data.imageUrl" alt="" appDefaultImage lazy="true" />
    <div class="sponsored-banner__image-wrapper__overlay">
      <p class="title">{{ data?.title || '' | humanize | truncateText: 50 }}</p>
      <p [innerHTML]="data?.subTitle | truncateText: 100" [tippy]="details" class="description" style="color: var(--white)"></p>
    </div>
  </div>
</ng-template>

<ng-template #details>
  <p [innerHTML]="sponsoredAds[0]?.subTitle" style="color: var(--text-color-light)"></p>
</ng-template>
